import { styled, createTheme } from '@mui/material/styles';
import {darken, lighten, alpha} from "@mui/material";
import { deepmerge } from '@mui/utils';
import * as Bs4Utils from '../Bs4Components/Bs4Utils'
import Bs4MainWindow from '../Bs4MainWindow';

const colorPrimary  = '#022C57';

export const baseTheme = {    
  palette: {
    //mode: 'dark',
    primary: {      
      main: colorPrimary,
      //light: lighten(colorPrimary, 0.4),
      //dark: darken(colorPrimary, 0.4),      
    },
  },  
  typography: {
    button: {
      textTransform: 'none'
    },    
  },
  components: {
    MuiButtonGroup: {
      defaultProps: {        
        //variant: 'text',
        //variant: 'outlined',
        variant: 'contained',
        size: "small",
      },     
    },
    MuiLoadingButton:{
      defaultProps: {
        //variant: 'text',
        //variant: 'outlined',
        variant: 'contained',
        size: 'small',
      },
      variants: [{
          props: { size: "topMenu" },
          style: { padding: "0px 6px", },
        }, {
          props: { size: "extraSmall" },
          style: { padding: "0px 0px", },
        }
      ]
    },
    MuiButton: {
      defaultProps: {
        //variant: 'text',
        //variant: 'outlined',
        variant: 'contained',
        size: 'small',
      },
      variants: [{
          props: { size: "topMenu" },
          style: { padding: "0px 6px", },
        }, {
          props: { size: "extraSmall" },
          style: { padding: "0px 0px", },
        }
      ]
    },
    MuiLoadingButton: {
      defaultProps: {
        //variant: 'text',
        //variant: 'outlined',
        variant: 'contained',
        size: 'small',
      },
      variants: [{
          props: { size: "topMenu" },
          style: { padding: "0px 6px", },
        }, {
          props: { size: "extraSmall" },
          style: { padding: "0px 0px", },
        }
      ]
    },
    MuiToggleButtonGroup:{
      defaultProps: {        
        size: "small",
      },     
    },
    MuiToggleButton: {
      defaultProps: {        
        size: 'small',
      },
    },
    MuiIconButton: {
      defaultProps: {        
        size: 'small',
      },
    },
    MuiTextField: {
      defaultProps: {
        //variant: 'filled',
        //variant: 'outlined',
        variant: 'standard',
        size: "small",
        margin: 'dense', // 'dense', 'normal', 'none'        
      },      
    },
    MuiFormControl: {
      defaultProps: {
        //variant: 'filled',
        //variant: 'outlined',
        variant: 'standard',
        size: "small",
        margin: 'dense', // 'dense', 'normal', 'none'
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        size: "small",
      }
    },
    MuiSelect: {
      defaultProps: {
        size: "small",
        variant: 'standard',
        margin: 'dense', // 'dense', 'normal', 'none'
      }
    },
    MuiChip: {
      defaultProps: {
        size: 'small',
        variant: 'filled',
        //variant: 'outlined'
      }
    }
  }
};

const brighterColor = (bs4Style, color1, color2) => {
  try {
    const c = Bs4Utils.colorToRgba(bs4Style.color);
    const b = Bs4Utils.colorToRgba(bs4Style.backgroundColor);
    const dc = (c.r + c.g + c.b) * c.a;
    const db = (b.r + b.g + b.b) * b.a;
    //console.log('... brighter ...', c, dc, b, db, bs4Style)
    return dc > db ? color1 : color2;
  } catch(error) {
    //console.log('... brighter ... error ...', bs4Style)
    return color1;
  }
}

export let Bs4Theme = null;
export default function getBs4Theme () {

  const theme = createTheme(baseTheme);
  // let uxTemplateTheme = Bs4MainWindow.instance.uxTemplate.body?.Main?.theme;
  let uxTemplateTheme = Bs4MainWindow.instance.bs4MainWindowUx.uxTemplate.body?.Main?.theme;

  const defaultUx = {
    theme: {
      backgroundColor: lighten(theme.palette.primary.main, 0.9)
    }
  };
  
  // const uxTemplateTmp = deepmerge(defaultUx, Bs4MainWindow.instance.uxTemplate.body?.Main);
  const uxTemplateTmp = deepmerge(defaultUx, Bs4MainWindow.instance.bs4MainWindowUx.uxTemplate.body?.Main);

  theme.Bs4 = {};
  theme.Bs4.backgroundColor = uxTemplateTmp.theme.backgroundColor;
  theme.Bs4.spacing = uxTemplateTmp.theme.spacing;
  theme.Bs4.backgroundPicture = uxTemplateTheme.backgroundPicture;

  if (uxTemplateTheme?.primary) {
    theme.palette.primary.main = uxTemplateTheme.primary;
    theme.palette.primary.light = lighten(theme.palette.primary.main, 0.5);
    theme.palette.primary.dark = darken(theme.palette.primary.main, 0.4);    
  }

  if (uxTemplateTheme?.secondary) {
    theme.palette.secondary.main = uxTemplateTheme.secondary;
    theme.palette.secondary.light = lighten(theme.palette.secondary.main, 0.5);
    theme.palette.secondary.dark = darken(theme.palette.secondary.main, 0.4);    
  }

  if (uxTemplateTheme?.info) {
    theme.palette.info.main = uxTemplateTheme.info;
    theme.palette.info.light = lighten(theme.palette.info.main, 0.5);
    theme.palette.info.dark = darken(theme.palette.info.main, 0.4);    
  }

  if (uxTemplateTheme?.success) {
    theme.palette.success.main = uxTemplateTheme.success;
    theme.palette.success.light = lighten(theme.palette.success.main, 0.5);
    theme.palette.success.dark = darken(theme.palette.success.main, 0.4);    
  }

  if (uxTemplateTheme?.warning) {
    theme.palette.warning.main = uxTemplateTheme.warning;
    theme.palette.warning.light = lighten(theme.palette.warning.main, 0.5);
    theme.palette.warning.dark = darken(theme.palette.warning.main, 0.4);    
  }
  
  if (uxTemplateTheme?.error) {
    theme.palette.error.main = uxTemplateTheme.error;
    theme.palette.error.light = lighten(theme.palette.error.main, 0.5);
    theme.palette.error.dark = darken(theme.palette.error.main, 0.4);    
  }
  
  if (uxTemplateTheme.borderRadius || uxTemplateTheme.borderRadius === 0) {
    theme.shape.borderRadius = uxTemplateTheme.borderRadius;
  }

  if (uxTemplateTheme?.inputVariant) {
    theme.components.MuiTextField.defaultProps.variant = uxTemplateTheme.inputVariant;
    theme.components.MuiFormControl.defaultProps.variant = uxTemplateTheme.inputVariant;
  }

  if (uxTemplateTheme?.inputSize) {
    theme.components.MuiTextField.defaultProps.size = uxTemplateTheme.inputSize;
    theme.components.MuiFormControl.defaultProps.size = uxTemplateTheme.inputSize;
    theme.components.MuiAutocomplete.defaultProps.size = uxTemplateTheme.inputSize;    
  }
  if (uxTemplateTheme?.inputMargin) {
    theme.components.MuiTextField.defaultProps.margin = uxTemplateTheme.inputMargin;
    theme.components.MuiFormControl.defaultProps.margin = uxTemplateTheme.inputMargin;
    theme.components.MuiAutocomplete.defaultProps.margin = uxTemplateTheme.iinputMargin;    
  }

  if (uxTemplateTheme?.buttonVariant) {
    theme.components.MuiButtonGroup.defaultProps.variant = uxTemplateTheme.buttonVariant;
    theme.components.MuiButton.defaultProps.variant = uxTemplateTheme.buttonVariant;
  }

  if (uxTemplateTheme?.buttonSize) {
    theme.components.MuiButtonGroup.defaultProps.size = uxTemplateTheme.buttonSize;
    theme.components.MuiButton.defaultProps.size = uxTemplateTheme.buttonSize;
    theme.components.MuiToggleButtonGroup.defaultProps.size = uxTemplateTheme.buttonSize;
    theme.components.MuiToggleButton.defaultProps.size = uxTemplateTheme.buttonSize;
    theme.components.MuiIconButton.defaultProps.size = uxTemplateTheme.buttonSize;    
    theme.components.MuiLoadingButton.defaultProps.size = uxTemplateTheme.buttonSize;        
  }

  Bs4Theme = theme

  return Bs4Theme;
}

export const getFieldTheme = (theme, bs4StyleStr) => {
  return getFieldThemeObj(theme, Bs4Utils.getBs4Style(bs4StyleStr))
}

export const getFieldThemeObj = (oldTheme, bs4Style) => {
  
  if (!bs4Style) return oldTheme;

  // 2025-03-27 61861 – Kolorystyka elementu switch [Core]
  if (!bs4Style.backgroundColor) bs4Style.backgroundColor = oldTheme.Bs4.backgroundColor || '#fff';

  const fcolor = 0.3;
  const theme = {
    palette: {
      primary: {},
    },
    Bs4: {
      verticalMenu: {
        box: {},
      }
    }
  };

  if (bs4Style?.color) {
    theme.palette.text = {
      primary: bs4Style.color,
      secondary: alpha(bs4Style.color, 0.7), 
      disabled: alpha(bs4Style.color, 0.4),
    };

    theme.palette.primary = {
      main: bs4Style.color,
      light: lighten(bs4Style.color, fcolor),
      dark: darken(bs4Style.color, fcolor),
      contrastText: brighterColor(bs4Style, darken(bs4Style.color, 0.5), lighten(bs4Style.color, 0.7)),
    };    

    theme.palette.secondary = {
      main: bs4Style.color,
      light: lighten(bs4Style.color, fcolor),
      dark: darken(bs4Style.color, fcolor),
      contrastText: brighterColor(bs4Style, darken(bs4Style.color, 0.5), lighten(bs4Style.color, 0.7)),
    };

    theme.palette.common =  {
      black: bs4Style.color,
      white: bs4Style.backgroundColor,
    }

    theme.palette.action = {
      active: bs4Style.color, //"#fff",
      hover: alpha(bs4Style.color, 0.08), //"rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: alpha(bs4Style.color, 0.16), //"rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: alpha(bs4Style.color, 0.3), //"rgba(255, 255, 255, 0.3)",
      disabledBackground: alpha(bs4Style.color, 0.12), //"rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: alpha(bs4Style.color, 0.12), // "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24,
    };
      
    theme.palette.divider = alpha(bs4Style.color, 0.7);  

    const borderInputColor = theme.palette.divider; // alpha(bs4Style.color, 0.7);
    theme.components = {
      MuiTextField: {
        styleOverrides: {       
          root: {  
            '& .MuiInput-underline:before': {borderBottomColor: borderInputColor},
            '& .MuiInput-underline:after': {borderBottomColor: borderInputColor}, 
            '& .MuiFilledInput-underline:before': {borderBottomColor: borderInputColor}, 
            '& .MuiFilledInput-underline:after': {borderBottomColor: borderInputColor}, 
            '& .MuiOutlinedInput-root': {
              '& fieldset': {borderColor: borderInputColor},                            
            },
          },
        },
      },
      MuiFormControlLabel: {        
        styleOverrides: {       
          root: {  
            '& .MuiFormControlLabel-label': {color: bs4Style.color},            
          },
        },
      }
    }
  }

  if (bs4Style.backgroundColor) {
    theme.palette.background = {
      default: bs4Style.backgroundColor,
      paper: bs4Style.backgroundColor,
    }

    // fieldTheme.palette.action = {
    //     //active: darken(bs4Style.backgroundColor, 0.54), //"rgba(0, 0, 0, 0.54)",
    //     //hover: darken(bs4Style.backgroundColor, 0.04), //"rgba(0, 0, 0, 0.04)",
    //     hoverOpacity: 0.504,
    //     //selected: darken(bs4Style.backgroundColor, 0.08), //"rgba(0, 0, 0, 0.08)",
    //     selectedOpacity: 0.208,
    //     //disabled: darken(bs4Style.backgroundColor, 0.26), //"rgba(0, 0, 0, 0.26)",
    //     //disabledBackground: darken(bs4Style.backgroundColor, 0.12), //"rgba(0, 0, 0, 0.12)",
    //     //disabledOpacity: 0.38,
    //     //focus: darken(bs4Style.backgroundColor, 0.12), //"rgba(0, 0, 0, 0.12)",
    //     focusOpacity: 0.512,
    //     activatedOpacity: 0.512
    // };

    theme.palette.primary.contrastText = bs4Style.backgroundColor;
  }    

  return deepmerge(oldTheme, theme)
}

